// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"58d088a2","126":"e758ba30","171":"91885eeb","249":"a83975e3","453":"76bec630"}[chunkId] + ".chunk.js";
};